import { ChangeEvent, FormEvent, useState } from "react";
import BotoxLogo from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { UserData } from "../utils/types";
import { ACTIONS, useScore } from "../utils/constants";
import { addUserData, updateUserData } from "../utils/firebase-service";
export default function Home() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<UserData>({ name: "" });
  const submitAction = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { name } = formData;
    if (name) {
      dispatch({ type: ACTIONS.RESET });
      const code = `${name}_${Math.random() * 10}`;
      await addUserData({ name, code });
      dispatch({ type: ACTIONS.SET_USER_DATA, payload: { name, code } });

      navigate("/game", { replace: true });
    }
  };
  const updateFormData = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData((prevData: UserData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };
  const { dispatch } = useScore();
  return (
    <section className="home-container">
      <div className="logo-container">
        <img src={BotoxLogo} />
      </div>
      <div className="form-container">
        <form onSubmit={submitAction}>
          <div className="form-control">
            <input
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                updateFormData(e);
              }}
              value={formData.name}
              type="text"
              name="name"
              required
              autoComplete="off"
              placeholder="Enter Your Name"
            />
          </div>

          <button>START NOW</button>
        </form>
      </div>
    </section>
  );
}
